<template>
  <div class="w-100 h-100 service">
    <header>
      {{ $t('saleDocument.title') }}
      <a-space>
        <!-- <a-button type="primary" @click="getData(false)">查询</a-button>
        <a-button type="primary" @click="visible = true; title='新增档案'">新增</a-button> -->
        <a-button type="primary" @click="getData(false)" v-if="authorities.find(a => a.code === 'after:sale:document:query')">{{ $t('buttons.search') }}</a-button>
        <a-button type="primary" @click="visible = true; title=$t('saleDocument.addTitle')" v-if="authorities.find(a => a.code === 'after:sale:document:insert')">{{ $t('buttons.add') }}</a-button>
      </a-space>
    </header>
    <el-table
      :key="lang"
      stripe
      style="width: 100%"
      v-loading="isLoading"
      :data="list"
      :header-cell-style="{ backgroundColor: '#fafafa' }"
    >
      <el-table-column prop="orderNum" label="订单编号" width="160">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
            {{ $t('orders.code') }}
          </div>
          <a-input v-model.trim="queryParams.orderNum" allow-clear @keyup.enter="getData(true)" />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo.orderNum">{{ scope.row.orderNum }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="equipmentCode" label="整机编号" width="160">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
            {{ $t('device.code') }}
          </div>
          <a-input v-model.trim="queryParams.equipmentCode" allow-clear @keyup.enter="getData(true)" />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo.equipmentCode">{{ scope.row.equipmentCode || scope.row.sbbh }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="equipmentName" label="设备名称" width="200">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
            {{ $t('common.deviceName') }}
          </div>
          <a-input v-model.trim="queryParams.equipmentName" allow-clear @keyup.enter="getData(true)" />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo.equipmentName">{{ scope.row.equipmentName || scope.row.sbmc }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="equipmentModel" label="规格型号" width="100">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
            {{ $t('common.model') }}
          </div>
          <a-input v-model.trim="queryParams.equipmentModel" allow-clear @keyup.enter="getData(true)" />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo.equipmentModel">{{ scope.row.equipmentModel || scope.row.sbxh }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="serviceType" label="服务类型" width="100">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
            {{ $t('saleDocument.serviceType') }}
          </div>
          <a-select
            v-model="queryParams.serviceType"
            style="width: 80px"
            @change="getData(true)"
          >
            <a-select-option value>{{ $t('common.all') }}</a-select-option>
            <a-select-option v-for="(value, key) in typeMap" :key="key">{{ value }}</a-select-option>
          </a-select>
        </template>
        <template slot-scope="scope">
          {{ typeMap[scope.row.serviceType] }}
        </template>
      </el-table-column>
      <el-table-column prop="customer" label="客户名称" width="220">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
            {{ $t('common.customerName') }}
          </div>
          <a-input v-model.trim="queryParams.customer" allow-clear @keyup.enter="getData(true)" />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo.customer">{{ scope.row.customer || scope.row.gsmc }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="updateman" label="修改人" width="130">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
            {{ $t('saleDocument.updateman') }}
          </div>
          <a-input v-model.trim="queryParams.updateman" allow-clear @keyup.enter="getData(true)" />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo.updateman">{{ scope.row.updateman }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="serviceMan" label="服务员" width="130">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
            {{ $t('common.serviceMen') }}
          </div>
          <a-input v-model.trim="queryParams.serviceman" allow-clear @keyup.enter="getData(true)" />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo.serviceman">{{ scope.row.serviceman }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="serviceTime" label="服务时间" width="200">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
            {{ $t('saleDocument.serviceTime') }}
          </div>
        </template>
        <template slot-scope="scope">
          {{ scope.row.serviceTime }}
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="修改时间" width="200">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
            {{ $t('saleDocument.updateTime') }}
          </div>
        </template>
        <template slot-scope="scope">
          {{ scope.row.updateTime }}
        </template>
      </el-table-column>
      <el-table-column prop="createman" label="创建人" width="120">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
            {{ $t('saleDocument.createman') }}
          </div>
        </template>
        <template slot-scope="scope">
          {{ scope.row.createman }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="200">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
            {{ $t('saleDocument.createTime') }}
          </div>
        </template>
        <template slot-scope="scope">
          {{ scope.row.createTime }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" fixed="right">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">
            {{ $t('common.operation') }}
          </div>
        </template>
        <template slot-scope="scope">
          <!-- <a-button style="padding-left: 0; margin-left: -3px" type="link" @click="onEdit(scope.row)">编辑</a-button> -->
          <a-button style="padding-left: 0; margin-left: -3px" type="link" @click="onEdit(scope.row)" v-if="authorities.find(a => a.code === 'after:sale:document:update')">{{ $t('buttons.edit') }}</a-button>
          <a-popconfirm
            :title="$t('messages.ctrd')"
            :ok-text="$t('common.okText')"
            :cancel-text="$t('common.cancelText')"
            @confirm="removeService(scope.row)"
          >
            <!-- <a-button :loading="scope.row.loading" type="link" style="padding-left: 0">删除</a-button> -->
            <a-button :loading="scope.row.loading" type="link" style="padding-left: 0" v-if="authorities.find(a => a.code === 'after:sale:document:delete')">{{ $t('buttons.delete') }}</a-button>
          </a-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <a-pagination
      style="float: right; margin-top: 20px; padding-bottom: 20px"
      :current="pagination.current"
      :total="pagination.total"
      @change="handleTableChange"
    />
    <ServiceModal
      :visible="visible"
      :title="title"
      :typeMap="typeMap"
      :closeModal="closeModal"
      :record="record"
    />
  </div>
</template>

<script>
import ServiceModal from '@/components/common/ServiceModal'
import TextHighlight from 'vue-text-highlight'
import { getDict } from '@/api/dict'
import { getList, removeS } from '@/api/service'

export default {
  components: { ServiceModal, TextHighlight },
  data() {
    return {
      authorities: [],
      visible: false,
      title: '',
      typeMap: {},
      queryParams: {
        orderNum: '',
        serviceType: '',
        equipmentCode: '',
        equipmentName: '',
        equipmentModel: '',
        customer: '',
        servicehours: '',
        serviceContent: '',
        serviceman: '',
        updateman: ''
      },
      highLightInfo: {
        orderNum: '',
        serviceType: '',
        equipmentCode: '',
        equipmentName: '',
        equipmentModel: '',
        customer: '',
        servicehours: '',
        serviceContent: '',
        serviceman: '',
        updateman: ''
      },
      list: [],
      isLoading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      record: undefined
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang() {
      this.setTypeMap()
    }
  },
  created() {
    this.setTypeMap()
    const a = JSON.parse(sessionStorage.getItem("authorities"));
    if (a?.length) {
      this.authorities = a;
    } else {
      this.authorities = this.getAuthorities(this.$route.path);
    }
    // this.authorities = [
    //   {
    //     code: 'after:sale:document:query'
    //   },
    //   {
    //     code: 'after:sale:document:insert'
    //   },
    //   {
    //     code: 'after:sale:document:update'
    //   },
    //   {
    //     code: 'after:sale:document:delete'
    //   },
    // ]
    this.getData()
  },
  methods: {
    onEdit(r) {
      this.title = this.$t('saleDocument.editTitle')
      this.record = r
      this.visible = true
    },
    async setTypeMap() {
      try {
        let map = {}
        const lang = this.lang === 'en' ? 'en-US' : 'zh-CN'
        const type = await getDict(lang, 'afterSaleServerItem')
        type.data.content.forEach(c => {
          map[c.value] = c.text
        })
        this.typeMap = map
      } catch(e) {
        console.log(e)
      }
    },
    closeModal(f) {
      this.visible = false
      this.record = undefined
      if (f) {
        this.getData()
      }
    },
    async getData(rp) {
      if (!this.authorities.find(a => a.code === 'after:sale:document:query')) {
        return this.$message.warn('暂无查询权限')
      }
      this.isLoading = true
      if (rp) {
        this.pagination.current = 1
      }
      try {
        const { data } = await getList(this.pagination.current, this.pagination.pageSize, this.queryParams)
        this.list = data.records
        this.pagination.total = data.total
        for (let k in this.highLightInfo) {
          this.highLightInfo[k] = this.queryParams[k]
        }
      } catch(e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    handleTableChange(current) {
      this.pagination.current = current
      this.getData()
    },
    async removeService(row) {
      row.loading = true
      this.list = [...this.list]
      try {
        const { message } = await removeS(row.id)
        this.$message.success(message)
        this.getData()
      } catch(e) {
        console.log(e)
      } finally {
        row.loading = false
        this.list = [...this.list]
      }
    }
  }
}
</script>

<style lang="less" scoped>
.service {
  padding: 15px;
  header {
    font-size: 20px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  div {
    position: relative;
  }
  span {
    position: relative;
  }
  .anticon-caret-up {
    position: absolute;
    top: -1px;
    right: -18px;
    font-size: 14px;
    color: #ccc;
  }
  span.ASC .anticon-caret-up {
    color: #1890ff;
  }
  span.icons {
    position: absolute;
    right: 18px;
  }
  span.DESC .anticon-caret-down {
    color: #1890ff;
  }
  .anticon-caret-down {
    position: absolute;
    top: 8px;
    right: -18px;
    font-size: 14px;
    color: #ccc;
  }
  /deep/ .ant-select-selection-selected-value {
    font-weight: normal !important;
  }
  /deep/ .el-table__empty-text {
    position: fixed;
    right: calc(50% - 100px);
    transform: translateX(50%);
  }
}
</style>